import React, { useEffect, useState } from "react";
import SparePartsKeys_ProductList from "./SparePartsKeys_ProductList";
import ImageSlider from "/Foundation/React/code/Components/ImageSlider";

const SparePartsKeys_Product = ({ product, translations, dealerLocatorLink, isKeysAndLocks }) => {
    const [additionalData, setAdditionalData] = useState();
    const id = product.ProductId ? product.ProductId : product.PimId;
    const getAdditionalData = () => {
        if (!product)
            return;

        fetch(`/api/sitecore/spareparts/search?query=${id}`)
            .then((response) => response.json())
            .then((data) => {
                setAdditionalData(data);
            })
            .catch((error) => {
            });

    }

    const setUrl = () => {
        const url = new URL(window.location);
        url.searchParams.set('q', id);
        window.history.replaceState({}, '', url);
    }

    useEffect(() => {
        getAdditionalData();
        setUrl();
    }, [product]);

    return <div className="sparePartsKeys__product thule-container mt-10 mt-lg-15">
        {product && additionalData && <>
            <div className="d-flex flex-column align-items-center">
                <h2 className="heading3">{additionalData?.ProductName}</h2>
                {(additionalData?.AvailableFrom || additionalData?.AvailableTo) && (
                    <span className="paragraph">
                        {translations.Available}: {additionalData?.AvailableFrom} - {additionalData?.AvailableTo}
                    </span>
                )}
                <div className="product__imageWrapper">
                    {product.ImageUrl && <img src={product.ImageUrl} alt={product.WebTitle2} />}
                </div>

                {additionalData && additionalData.Manuals?.length > 0 && <div className="product__manuals">
                    <h3 className="heading4 mb-6 mb-lg-7">{translations?.ProductManuals}</h3>
                    <ul className="ps-0">
                        {additionalData.Manuals.map((manual, index) => {
                            return <li key={index} className="mb-5"><i className="le-icon-file-text"></i><a target="_blank" className="paragraph" href={manual.Url}><span className="ms-3">{manual.Name}</span></a></li>
                        })}
                    </ul>
                </div>}

                <div className="product__spareparts w-100">
                    <h3 className="heading4 mb-6 mb-lg-7">{translations?.SpareParts}</h3>
                    <div>
                        <div className="product_bom mb-9 mb-lg-12">
                            {additionalData?.SparePartBOMModal?.length > 0 && <ImageSlider images={additionalData.SparePartBOMModal.map((bom) => { return { src: bom, alt: product.ProductName } })} />}
                        </div>
                        {additionalData && <SparePartsKeys_ProductList isKeysAndLocks={isKeysAndLocks} dealerLocatorLink={dealerLocatorLink} translations={translations} spareParts={additionalData.SpareParts} />}
                    </div>
                </div>
            </div>
        </>
        }
    </div>
}
export default SparePartsKeys_Product;